var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "m10.325 4.317c.426-1.756 2.924-1.756 3.35 0 .0639.2638.1892.50878.3657.715s.3992.36785.65.47175c.2507.10389.5225.1471.7931.12612s.5324-.10557.7642-.24687c1.543-.94 3.31.826 2.37 2.37-.1411.23166-.2256.49334-.2465.76377-.0209.27044.0223.542.126.79261.1038.25061.2652.4732.4712.64967.206.17645.4507.30185.7143.36595 1.756.426 1.756 2.924 0 3.35-.2638.0639-.5088.1892-.715.3657s-.3679.3992-.4717.65c-.1039.2507-.1472.5225-.1262.7931s.1056.5324.2469.7642c.94 1.543-.826 3.31-2.37 2.37-.2317-.1411-.4933-.2256-.7638-.2465-.2704-.0209-.542.0223-.7926.126-.2506.1038-.4732.2652-.6497.4712-.1764.206-.3018.4507-.3659.7143-.426 1.756-2.924 1.756-3.35 0-.0639-.2638-.1892-.5088-.36571-.715-.17649-.2062-.39918-.3679-.64994-.4717-.25076-.1039-.52252-.1472-.79314-.1262s-.53246.1056-.76421.2469c-1.543.94-3.31-.826-2.37-2.37.1411-.2317.22555-.4933.24648-.7638.02094-.2704-.02224-.542-.12601-.7926s-.26521-.4732-.4712-.6497c-.20598-.1764-.45071-.3018-.71427-.3659-1.756-.426-1.756-2.924 0-3.35.2638-.0639.50878-.1892.715-.36571.20622-.17649.36785-.39918.47175-.64994.10389-.25076.1471-.52252.12612-.79314s-.10557-.53246-.24687-.76421c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15 12c0 .7956-.3161 1.5587-.8787 2.1213s-1.3257.8787-2.1213.8787-1.5587-.3161-2.12132-.8787c-.56261-.5626-.87868-1.3257-.87868-2.1213s.31607-1.5587.87868-2.12132c.56262-.56261 1.32572-.87868 2.12132-.87868s1.5587.31607 2.1213.87868c.5626.56262.8787 1.32572.8787 2.12132z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.497ac01b864860d13ed8911ea9e90501.svg";
export { ForwardRef as ReactComponent };